// 火车票
const state = {
  searchParams: {}, // 查询参数
  fillParams: {}, // 订单填写参数
  confirmParams: {} // 订单确认参数
}
const getters = {
  trainSearchParams: state => state.searchParams,
  trainFillParams: state => state.fillParams,
  trainConfirmParams: state => state.confirmParams
}
const mutations = {
  setTrainSearchParams (state, data) {
    state.searchParams = data || {}
  },
  setTrainFillParams (state, data) {
    state.fillParams = data || {}
  },
  setTrainConfirmParams (state, data) {
    state.confirmParams = data || {}
  }
}
export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/trainStore.js